import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { ProjectNav } from "@/components/organisms/ProjectNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";
import Image from "next/image";

// images
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { ProjectCover } from "@/components/organisms/ProjectCover";
import projectIllust1 from "/public/project-illust1.webp";

export default function ProjectArticle(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={
          "調査から着手した電子マネーの設計･開発。数年に及ぶ長期プロジェクト"
        }
        pageDescription={
          "株式会社トッカシステムズのプロジェクト事例。調査から着手した電子マネーの設計･開発。数年に及ぶ長期プロジェクト。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/project/1"}
        imgUrl={"/public/project-illust1.webp"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Project",
                  path: "/project/",
                },
                {
                  name: "調査から着手した電子マネーの設計･開発。数年に及ぶ長期プロジェクト",
                },
              ]}
            />
            <Inner className="pt-0 pb-10 md:pt-6 md:pb-20">
              {/* cover */}
              <ProjectCover
                id="1"
                href="/career/voice/1"
                title="調査から着手した<br class='sp'/>電子マネーの設計･開発。<br />数年に及ぶ長期プロジェクト"
                intro="電子マネーの設計と開発を請け負いました。アプリ自体はすでにリリースされており、新たな機能を開発して欲しいという、クライアントからのオーダー。トッカシステムズではアプリブラウザから開かれる画面を構築しました。まずは競合他社の調査から始めました。"
                src="/project-keyVisual1.svg"
                imageClassName="2xs:right-[14px] 2xs:top-[14px] xs:right-[15px] xs:top-[20px] right-[30px] top-[30px] aspect-1/1 2xs:w-[104px] xs:w-[144px] sm:w-[244px] md:top-[40px] md:right-[40px] md:w-[200px] lg:top-1/4 lg:right-[80px] lg:w-[272px]"
                // imageClassName="2xs:right-[14px] 2xs:top-[14px] xs:right-[15px] xs:top-[20px] aspect-1/1 2xs:w-[76px] xs:w-[88px] md:top-1/4 md:right-[40px] md:w-[144px] lg:top-1/4 lg:right-[80px] lg:w-[220px]"
                bgClassName="bg-project-no1"
                tag={["Digital Products", "Infra Structure", "AWS"]}
              />
              {/* content */}
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>プロジェクトの期間を教えてください</Interviewer>
                <Interviewee speaker="A">
                  おおよそ2年かかりました。要件定義から設計開発、各種試験に1年かけ、その後一度リリースしてから、新機能を追加しました。機能の追加は随時2か月に1回のペース行いました。
                </Interviewee>
                <Interviewer>どのような工程から始めましたか？</Interviewer>
                <Interviewee speaker="A">
                  バーコード決済の市場調査、競合他社の調査から始めました。
                </Interviewee>
                <Interviewer>どのようなメンバー構成でしたか？</Interviewer>
                <Interviewee speaker="A">
                  開発チーム、試験チームとわかれて計6名です。開発フェーズ・試験フェーズなど時期によって、構成を入れ替えながら、プロジェクトを進めました。
                </Interviewee>
                <div className="relative aspect-2/1">
                  <Image
                    src={projectIllust1}
                    alt="調査から着手した電子マネーの設計･開発。数年に及ぶ長期プロジェクト"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <Interviewer>成功したなと思えたことはありますか？</Interviewer>
                <Interviewee speaker="A">
                  かなり大規模なプロジェクトだったので、自分が1年・2年と、がんばって作ったモノが世に出て、実際に自分が使ってみて、社会に影響を及ぼすことができたなぁ自覚できたのが嬉しかったです。
                </Interviewee>
                <Interviewer>
                  もっとこうだったらよかったということがありますか？
                </Interviewer>
                <Interviewee speaker="A">
                  まれに曖昧な要件があるので、その都度、より要件を明確にしながら進められたら良かったなと思いました。やはりスケジュールがきつい時期もあったので、タスク管理の改善をしていきたい。他社との連携の中で、時間がとられる中で、ルールを作り進めることは難しいが、クライアントと直にやりとりするタイミングがあるので、チームとしてもっと連携していれば良かった。
                </Interviewee>
                <Interviewer>
                  このプロジェクトを経て今後、挑んでみたいプロジェクトはありますか？
                </Interviewer>
                <Interviewee speaker="A">
                  スマホのアプリのUIや、業務システムのUIアプリをやりたいと思っていました。
                </Interviewee>
                <Interviewee speaker="D">
                  もう少しマーケ寄りの案件が見つかると良いな。みんなCMSが得意だと思うので。
                </Interviewee>
                <Interviewee speaker="B">
                  自社パッケージや自社サービスがやりたいな。と。
                </Interviewee>
                <Interviewee speaker="C">
                  私はプログラム書ければ何でもいいです（笑）
                </Interviewee>
                <Interviewer>
                  最後に、一緒に働いてみたいと思う人を教えてください。
                </Interviewer>
                <Interviewee speaker="A">
                  技能は大事だけど、仕事にも慣れれば、後からできるようなるので、それより意図を汲んで行動できる人かなぁ。
                </Interviewee>
                <Interviewee speaker="C">
                  コミュニケーションが一方通行にならない人。思いやりのある人。
                </Interviewee>
                <Interviewee speaker="B">
                  インフラの技術もあって、自分に技術を教えてくれる人（笑）
                </Interviewee>
                <Interviewee speaker="D">
                  疑問を持って返してくれる人、新しいことをしたいと思っている人がいい。
                </Interviewee>
                <Interviewee speaker="A">
                  新しい技術を追わなければいけないから、モチベーションが高くて、好奇心が旺盛な人に自分も刺激をもらいたいですね。
                </Interviewee>
              </div>
              <ProjectNav />
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
